import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { IconSize } from '@freelancer/ui/icon';
import { PictureLayout, PictureObjectFit } from '@freelancer/ui/picture';

@Component({
  standalone: false,
  selector: 'app-login-signup-method-button',
  template: `
    <fl-button
      class="LoginSignupMethod-container"
      [flTrackingLabel]="
        stepLabel
          ? stepLabel + '-' + providerLabel + 'Button'
          : providerLabel + 'Button'
      "
      [display]="'block'"
      [disabled]="disabled"
      [attr.data-disabled]="disabled"
      [color]="ButtonColor.CUSTOM"
      [size]="ButtonSize.LARGE"
    >
      <div class="LoginSignupMethod-button">
        @if (ssoIconSource) {
          <fl-picture
            class="LoginSignupMethod-button-logoIcon mr-xxsmall"
            alt="{{ providerLabel }} icon"
            i18n-alt="{{ providerLabel }} icon alt"
            [layout]="PictureLayout.RESPONSIVE"
            [objectFit]="PictureObjectFit.CONTAIN"
            [src]="ssoIconSource"
          ></fl-picture>
        } @else {
          <fl-icon
            class="LoginSignupMethod-button-icon"
            [fillIconFont]="false"
            [name]="'ui-mail'"
            [useIconFont]="true"
            [size]="IconSize.SMALL"
          ></fl-icon>
        }
        <p
          class="text-color-inherit text-size-inherit LoginSignupMethod-button-text text-center font-medium"
          i18n="Use {{ providerLabel }} to sign up or log in"
        >
          Continue with {{ providerLabel }}
        </p>
      </div>
    </fl-button>
  `,
  styleUrls: ['./login-signup-method-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginSignupMethodButtonComponent implements OnInit {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  IconSize = IconSize;
  PictureLayout = PictureLayout;
  PictureObjectFit = PictureObjectFit;

  @HostBinding('class.Busy')
  @Input()
  busy = false;

  @HostBinding('attr.data-disabled')
  @HostBinding('class.Disabled')
  @Input()
  disabled = false;
  @Input() provider: 'google' | 'apple' | 'facebook' | 'email' = 'email';
  @Input() stepLabel = '';

  providerLabel: string;
  ssoIconMap = {
    google: '/google/google-icon.svg',
    apple: '/apple/apple-logo-black.svg',
    facebook: '/facebook/facebook-icon-rounded.svg',
  };
  ssoIconSource?: string;

  ngOnInit(): void {
    this.providerLabel =
      this.provider !== 'email'
        ? this.provider.charAt(0).toUpperCase() + this.provider.slice(1)
        : this.provider;
    this.ssoIconSource =
      this.provider !== 'email' ? this.ssoIconMap[this.provider] : undefined;
  }
}
